<script lang="ts">
  import MediaCredit from '../MediaCredit.svelte'
  import VideoPlayer from '../VideoPlayer.svelte'
  import type { SerializedVideoBlock } from '../../types'

  let { block, priority = false }: { block: SerializedVideoBlock; priority?: boolean } = $props()
</script>

<figure class="video-block">
  <div class="video-block-player">
    <VideoPlayer video={block.video} {priority} />
    <MediaCredit />
  </div>
  <figcaption class="video-block-caption">{block.caption}</figcaption>
</figure>

<style>
  .video-block {
    grid-column: full;
    display: grid;
    grid-template-columns: subgrid;
  }

  .video-block-player {
    grid-column: content;
    position: relative;
  }

  .video-block-caption {
    grid-column: content;
  }

  @media (--mobile) {
    .video-block-player {
      grid-column: full;
    }
  }
</style>
